import { ContextScopedFindInput } from 'vscode/vscode/vs/platform/history/browser/contextScopedHistoryWidget';
import { NotebookFindInputFilterButton } from 'vscode/vscode/vs/workbench/contrib/notebook/browser/contrib/find/notebookFindReplaceWidget';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { getDefaultHoverDelegate } from 'vscode/vscode/vs/base/browser/ui/hover/hoverDelegateFactory';
import { Toggle } from 'vscode/vscode/vs/base/browser/ui/toggle/toggle';
import { Emitter } from 'vscode/vscode/vs/base/common/event';

const _moduleId = "vs/workbench/contrib/search/browser/searchFindInput";
const NLS_AI_TOGGLE_LABEL = ( localizeWithPath(_moduleId, 0, "Use AI"));
class SearchFindInput extends ContextScopedFindInput {
    constructor(container, contextViewProvider, options, contextKeyService, contextMenuService, instantiationService, filters, shouldShowAIButton,
    filterStartVisiblitity) {
        super(container, contextViewProvider, options, contextKeyService);
        this.contextMenuService = contextMenuService;
        this.instantiationService = instantiationService;
        this.filters = filters;
        this._filterChecked = false;
        this._onDidChangeAIToggle = this._register(( (new Emitter())));
        this.onDidChangeAIToggle = this._onDidChangeAIToggle.event;
        this.shouldNotebookFilterBeVisible = false;
        this._findFilter = this._register(( (new NotebookFindInputFilterButton(filters, contextMenuService, instantiationService, options, ( localizeWithPath(_moduleId, 1, "Notebook Find Filters"))))));
        this._aiButton = this._register(( (new AIToggle({
            appendTitle: '',
            isChecked: false,
            ...options.toggleStyles
        }))));
        this.setAdditionalToggles([this._aiButton]);
        this._updatePadding();
        this.controls.appendChild(this._findFilter.container);
        this._findFilter.container.classList.add('monaco-custom-toggle');
        this.filterVisible = filterStartVisiblitity;
        this.sparkleVisible = shouldShowAIButton;
        this._register(this._aiButton.onChange(() => {
            if (this.regex) {
                this.regex.visible = !this._aiButton.checked;
            }
            if (this.wholeWords) {
                this.wholeWords.visible = !this._aiButton.checked;
            }
            if (this.caseSensitive) {
                this.caseSensitive.visible = !this._aiButton.checked;
            }
            if (this._aiButton.checked) {
                this._findFilter.visible = false;
            }
            else {
                this.filterVisible = this.shouldNotebookFilterBeVisible;
            }
            this._updatePadding();
        }));
    }
    _updatePadding() {
        this.inputBox.paddingRight =
            (this.caseSensitive?.visible ? this.caseSensitive.width() : 0) +
                (this.wholeWords?.visible ? this.wholeWords.width() : 0) +
                (this.regex?.visible ? this.regex.width() : 0) +
                (this._findFilter.visible ? this._findFilter.width() : 0) +
                (this._aiButton.visible ? this._aiButton.width() : 0);
    }
    set sparkleVisible(visible) {
        this._aiButton.visible = visible;
        this._updatePadding();
    }
    set filterVisible(visible) {
        this.shouldNotebookFilterBeVisible = visible;
        if (this._aiButton.visible && this._aiButton.checked) {
            return;
        }
        this._findFilter.visible = visible;
        this.updateFilterStyles();
        this._updatePadding();
    }
    setEnabled(enabled) {
        super.setEnabled(enabled);
        if (enabled && (!this._filterChecked || !this._findFilter.visible)) {
            this.regex?.enable();
        }
        else {
            this.regex?.disable();
        }
    }
    updateFilterStyles() {
        this._filterChecked =
            !this.filters.markupInput ||
                !this.filters.markupPreview ||
                !this.filters.codeInput ||
                !this.filters.codeOutput;
        this._findFilter.applyStyles(this._filterChecked);
    }
    get isAIEnabled() {
        return this._aiButton.checked;
    }
}
class AIToggle extends Toggle {
    constructor(opts) {
        super({
            icon: Codicon.sparkle,
            title: NLS_AI_TOGGLE_LABEL + opts.appendTitle,
            isChecked: opts.isChecked,
            hoverDelegate: opts.hoverDelegate ?? getDefaultHoverDelegate('element'),
            inputActiveOptionBorder: opts.inputActiveOptionBorder,
            inputActiveOptionForeground: opts.inputActiveOptionForeground,
            inputActiveOptionBackground: opts.inputActiveOptionBackground
        });
    }
}

export { SearchFindInput };
